import { Observable } from '../Observable/Observable';
export class EventBus {
    constructor() {
        this.events = new Map();
    }
    has(event) {
        return this.events.has(event);
    }
    get(event) {
        let observable = this.events.get(event);
        if (!observable) {
            observable = new Observable();
            this.events.set(event, observable);
        }
        return observable;
    }
    set(event, value) {
        const observable = this.get(event);
        observable.next(value);
        return observable;
    }
    next(event, value) {
        const observable = this.get(event);
        observable.next(value);
        return observable;
    }
}
